import { motion } from "framer-motion";
import { scrollToSection, EASE } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="overflow-hidden bg-[#142019] text-[#F7F4EF]">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 sm:px-10 sm:pt-28">
        <div className="flex flex-wrap items-end justify-between gap-10 border-b border-white/10 pb-14">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C8634B]">
              Victoria Beach Cottage . ca
            </p>
            <p className="mt-4 max-w-md font-serif text-2xl leading-snug text-[#F7F4EF]/90 sm:text-3xl">
              Now reserving Summer 2027. The lake is waiting.
            </p>
          </div>
          <button
            data-testid="footer-enquire-button"
            onClick={() => scrollToSection("#enquire")}
            className="rounded-full bg-[#C8634B] px-8 py-4 text-sm font-semibold tracking-wide text-[#F7F4EF] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#F7F4EF] hover:text-[#1E3323]"
          >
            Start an Enquiry
          </button>
        </div>

        <motion.p
          data-testid="footer-giant-word"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 1.1, ease: EASE }}
          className="select-none whitespace-nowrap py-10 text-center font-serif text-[13.5vw] leading-none tracking-tight text-[#F7F4EF]/[0.07] lg:text-[11rem]"
        >
          Victoria Beach
        </motion.p>

        <div className="flex flex-wrap items-center justify-between gap-6 border-t border-white/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#F7F4EF]/50">
            50.6978° N · 96.5617° W · Lake Winnipeg · Manitoba
          </p>
          <nav className="flex gap-6" data-testid="footer-nav">
            {[
              { label: "Gallery", href: "#gallery", testid: "footer-link-gallery" },
              { label: "Rates", href: "#rates", testid: "footer-link-rates" },
              { label: "Find Us", href: "#location", testid: "footer-link-location" },
              { label: "Reserve", href: "#enquire", testid: "footer-link-reserve" },
            ].map((link) => (
              <button
                key={link.href}
                data-testid={link.testid}
                onClick={() => scrollToSection(link.href)}
                className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#F7F4EF]/60 transition-colors hover:text-[#C8634B]"
              >
                {link.label}
              </button>
            ))}
          </nav>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#F7F4EF]/40">
            © 2026 Victoria Beach Cottage . ca · Est. 1922
          </p>
        </div>
      </div>
    </footer>
  );
}
